import { IconButtonStyledOutlined } from '@/components/common/iconButtonStyledOutlined';
import SearchIcon from '@/components/icons/search';
import UploadIcon from '@/components/icons/upload';
import StyledSelect from '@/components/common/styledSelect';
import { IClient } from '@/interfaces/clients';
import {
  List,
  ListItemButton,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

enum ClientListSortBy {
  Lastname = 'lastname',
}

const sortOptions = [
  { value: ClientListSortBy.Lastname, label: 'Lastname(A-Z)' },
];

type Props = {
  items: IClient[];
  selected: IClient | undefined;
  onSelect: (client?: IClient) => void;
};

const ClientList = ({ items, selected, onSelect }: Props) => {
  const [sortBy, setSortBy] = useState<ClientListSortBy>(
    ClientListSortBy.Lastname,
  );
  const handleSortByChange = (event: SelectChangeEvent) => {
    setSortBy(event.target.value as ClientListSortBy);
  };

  return (
    <Stack
      gap={1}
      width='312px'
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='flex-end'
      >
        <StyledSelect
          label='Sort By'
          options={sortOptions}
          value={sortBy}
          onChange={handleSortByChange}
        />

        <Stack
          gap={1.5}
          direction='row'
        >
          <IconButtonStyledOutlined variant='outlined'>
            <SearchIcon />
          </IconButtonStyledOutlined>

          <IconButtonStyledOutlined variant='outlined'>
            <UploadIcon />
          </IconButtonStyledOutlined>
        </Stack>
      </Stack>

      <List sx={{ overflow: 'visible', p: 0 }}>
        <ListItemButton
          selected={selected === undefined}
          onClick={() => {
            onSelect(undefined);
          }}
          sx={{ px: 3, py: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
        >
          <Typography variant='subtitle1'>All Clients</Typography>
        </ListItemButton>

        {items.map((item) => (
          <ListItemButton
            key={item.id}
            onClick={() => {
              onSelect(item);
            }}
            selected={selected?.id === item.id}
            sx={{ px: 3, py: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
          >
            {item.name}
          </ListItemButton>
        ))}
      </List>
    </Stack>
  );
};

export default ClientList;
